// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import aMap from 'vue-amap'   // 高德地图 - 这个引入的最好放在引入的vue上面
import Vue from 'vue'
import App from './App'
import store from './store/index'
import router from './router'
import BaiduMap from 'vue-baidu-map'
import global from './config/global'
import './assets/iconfont/iconfont.css';
import './assets/iconfont/iconfont.js'
import {checkBindWechat, binWechat, getOpenIdV2} from "@/api/user";

Vue.config.productionTip = false

var $ = require('jquery');
window.$ = $;

// Vuex 依赖 Promise (opens new window)。如果你支持的浏览器并没有实现 Promise (比如 IE)，那么你可以使用一个 polyfill 的库
import 'es6-promise/auto'

import Vuex from 'vuex'
Vue.use(Vuex)

Vue.use(BaiduMap, {
  ak: 'P1RQZmPT4YIjvWQuNNDHl6Ta3pQPlxLZ'
});

// 高德地图
Vue.use(aMap)
aMap.initAMapApiLoader({
  key: 'e9edb849d9bce43fe5ba2485615f5774	',  // 你的key
  plugin: ["AMap.Autocomplete", "AMap.Geocoder", "AMap.Geolocation"],//应用功能项
  v: '1.4.15', //版本
  uiVersion: '1.1' //ui版本
})

import axios from 'axios'
Vue.prototype.$axios = axios // 需要使用prototype将axios挂载到原型上 ，$后面是自己另起的名称，以后就可以使用该名称

Vue.prototype.$globalParams = global

import 'lib-flexible'

import {
  Button,
  Toast,
  Tabbar,
  TabbarItem,
  NavBar,
  Icon,
  Col,
  Row,
  Tab,
  Tabs,
  List,
  Empty,
  ActionSheet,
  Dialog,
  Form,
  Field,
  Cell,
  CellGroup,
  RadioGroup,
  Radio,
  Uploader,
  Picker,
  Popup,
  Search,
  DropdownMenu,
  DropdownItem,
  Switch,
  DatetimePicker,
  Cascader,
  Step,
  Steps,
  Image,
  Lazyload,
  Calendar,
  Overlay,
  NoticeBar,
  Grid,
  GridItem,
  Collapse,
  CollapseItem,
  Checkbox,
  CheckboxGroup,
  Badge,
  Swipe,
  SwipeItem,
  Loading,
  Pagination,
  GoodsAction,
  GoodsActionIcon,
  GoodsActionButton,
  Popover,
  ShareSheet,
  Progress, Tag, Area, Rate, Slider,TreeSelect
} from 'vant'

// 将所有 Toast 的展示时长设置为 3500 毫秒
Toast.setDefaultOptions({ duration: 3500 });

Vue
  .use(Button)
  .use(Toast)
  .use(Tabbar)
  .use(TabbarItem)
  .use(NavBar)
  .use(Icon)
  .use(Col)
  .use(Row)
  .use(Tab)
  .use(Tabs)
  .use(List)
  .use(Empty)
  .use(ActionSheet)
  .use(Dialog)
  .use(Form)
  .use(Field)
  .use(Cell)
  .use(CellGroup)
  .use(RadioGroup)
  .use(Radio)
  .use(Uploader)
  .use(Picker)
  .use(Popup)
  .use(Search)
  .use(DropdownMenu)
  .use(DropdownItem)
  .use(Switch)
  .use(DatetimePicker)
  .use(Cascader)
  .use(Step)
  .use(Steps)
  .use(Image)
  .use(Lazyload)
  .use(Calendar)
  .use(Overlay)
  .use(NoticeBar)
  .use(Grid)
  .use(GridItem)
  .use(Collapse)
  .use(CollapseItem)
  .use(Checkbox)
  .use(CheckboxGroup)
  .use(Badge)
  .use(Swipe)
  .use(SwipeItem)
  .use(Loading)
  .use(Pagination)
  .use(GoodsAction)
  .use(GoodsActionButton)
  .use(GoodsActionIcon)
  .use(Popover)
  .use(ShareSheet)
  .use(Progress)
  .use(Tag)
  .use(Area)
  .use(Rate)
  .use(Slider)
  .use(TreeSelect)

import echarts from 'echarts'
import {setStore} from '@/util/store'
import {getStore} from "./util/store";
Vue.prototype.$echarts = echarts

// 切换路由时取消正在pending的请求
router.beforeEach((to, from, next) => {
  store.commit('clearCancelToken')
  // console.log("from.path",from.path)
  localStorage.setItem("from", from.path);
  if (to.path=="login"){
    setStore({name:"userTenantList", content: ''})
    setStore({name:"currUserTenant", content: ''})
    setStore({name:"menuAll", content: ''})
    setStore({name:"menu", content: ''})
  }
  let code = getParam("code");
  let state = getParam("state");
  if (code && getStore({name: 'token'}) && state == 'bind') {

    let source = "WECHAT_MP";
    if (localStorage.getItem("wx_source") == 2) {
      source = "WECHAT_MP_AH"
    }
    let appId = global.GZ_APP_ID;
    if (localStorage.getItem("wx_source") == 2) {
      appId = global.AH_APP_ID;
    }
    getOpenIdV2(code, appId).then(openRes => {
      console.log(openRes);
      if (openRes && openRes.data.success && openRes.data.data) {
        let openid = openRes.data.data.openid;
        let wechatUser = openRes.data.data.wechatUser;

        if (openid) {
          let name = "", avatar = "", sex = "";
          if (wechatUser){
            let user = JSON.parse(wechatUser);
            name = user.nickname;
            avatar = user.headimgurl;
            sex = user.sex;
          }
          checkBindWechat(openid, source, name, avatar, sex).then(checkRes => {
            console.log(checkRes)
            // if ((!checkRes || !checkRes.success) && !checkRes.data.data) {
            //   binWechat(openid, source, name, avatar, sex).then(res => {
            //     if (!res || !res.success) {
            //       console.log(res);
            //     }
            //   });
            // }
            next();
          }).catch(()=>{
            next();
          });
        } else {
          next();
        }

      }

    }).catch(()=>{
      next();
    });
  } else{
    next();
  }



})

function getParam(name){
  return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ""])[1].replace(/\+/g, '%20')) || null;
}

new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js